import React, { useId, useState } from 'react'
import { ConfirmDialog } from '../../../../shared/sso-workspace/confirm-dialog'
import { serverMessage } from '../../../../shared/error/server-message'
import { useErrorLine } from '../../../../shared/error/use-error-line'
import { createKey } from './packages-api'

// Creates the package's publish key; the answer's secret goes to the
// one-time key dialog (onCreated).
export const CreateKeyDialog = ({ open, packageName, onCancel, onCreated }) => {
  const ids = { name: useId(), description: useId() }
  const [name, setName] = useState('GitHub Actions')
  const [description, setDescription] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, failure, setError] = useErrorLine()

  const cancel = () => { setError(null); onCancel() }
  const create = async () => {
    if (busy) return
    setBusy(true)
    setError(null)
    try {
      const answer = await createKey(packageName, { name: name.trim(), description: description.trim(), expires_at: null })
      setBusy(false)
      onCreated(answer)
    } catch (err) {
      setBusy(false)
      setError(serverMessage(err, "The key couldn't be created."), err)
    }
  }

  return (
    <ConfirmDialog open={open} title="Create publish key"
      body="A publish key lets CI publish versions of this package, and nothing else. The key is shown once."
      confirmText="Create key" confirmClassName="btn sw-btn-primary" confirmDisabled={!name.trim()} busy={busy} error={error} failure={failure}
      onConfirm={create} onCancel={cancel}>
      <div className="mb-3">
        <label className="sw-label" htmlFor={ids.name}>Key name</label>
        <input id={ids.name} className="form-control" value={name} onChange={e => setName(e.target.value)} />
      </div>
      <div className="mb-3">
        <label className="sw-label" htmlFor={ids.description}>Description (optional)</label>
        <input id={ids.description} className="form-control" value={description} onChange={e => setDescription(e.target.value)} />
      </div>
    </ConfirmDialog>
  )
}
